// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"4":"c2d44b4d","149":"d1ed3ddc","181":"73e0650e","386":"613496b3","389":"cc661462","415":"f65d3869","462":"386e121c","643":"06d350b9","681":"a8bcabfc","725":"d5940e62","796":"59ba4545","805":"20b800f4","978":"3368772f"}[chunkId] + ".chunk.js";
};